import { dialog } from "../../../nq-component";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { restUseCase } from "../../../usecases/rest";
import QRCode from "qrcode";
import {
  base64ToBlob,
  formatDate,
  formatDateUTC,
  formatTimeUTC,
  generateEmailBody,
} from "./utils/utils";
import { saveImageUseCase } from "../../../usecases/file";
import DialogSuccess from "./components/DialogSuccess";
import DialogAssignCoordinator from "./components/DialogAssignCoordinator";
import { submitEmployee } from "./apiClient";

class ApplicantBoardingFormPresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase,
    auditUseCase,
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.auditUseCase = auditUseCase;

    this.personal = {};
    this.employmentBackground = [];
    this.characterReferences = [];
    this.recruiter = null;
    this.image = "";

    this.onChangeEmployment = this.onChangeEmployment.bind(this);
    this.onChangecharacteref = this.onChangecharacteref.bind(this);
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.getClients();
    this.getLocations();
    this.getRecruiters();
    this.getOnBoard();

    this.employmentBackground = [...(this.object.employmentBackground || [])];
    this.characterref = [...(this.object.characterReferences || [])];
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    console.log("qwe", id);
    if (id) {
      const params = {
        include: ["all", "characterReferences", "recruiter", ""],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        console.log("jkjk", this.object);
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async getOnBoard() {
    const user = this.view.getCurrentUser();
    const collection = "on_boarding";
    const query = {
      where: { "recruiter.id": user?.id },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ onBoards: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getRecruiters() {
    const collection = "users";
    const query = {
      include: ["employee"],
      where: { "roles.id": "Recruiter" },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ recruiters: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  showImage() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src="/emailLoading2.gif"
              alt="loading"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <p style={{ color: "#D18237" }}>Sending email... Please wait...</p>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail) {
    console.log("gege", getApplicantEmail);
    // const match = qrData.match(
    //   /^(.*?)\/(.*?)\/(\d{4} -\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)\/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)\/([a-f0-9\-]{36})$/
    // );
    const match = qrData.match(
      /^(.*?)\/(.*?)\/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)\/(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)\/([a-f0-9\-]{36})\/(.*?)\/(.*?)\/(.*?)\/([a-f0-9\-]{36})\/(.*?)\/(.*?)$/,
    );

    console.log("match", match);

    if (!match) {
      console.error("Invalid QR Data format");
      return;
    }

    const [_, firstName, lastName, startDateTimeStr, endDateTimeStr] = match;
    const newStartDateTime = new Date(startDateTimeStr);
    const newEndDateTime = new Date(endDateTimeStr);

    const formattedDateUTC = formatDateUTC(newStartDateTime);
    const formattedStartTimeUTC = formatTimeUTC(newStartDateTime);
    const formattedEndTimeUTC = formatTimeUTC(newEndDateTime);

    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject: "EMAIL INVITATION FOR AN INTERVIEW",
      body: generateEmailBody(
        lastName,
        formattedDateUTC,
        formattedStartTimeUTC,
        formattedEndTimeUTC,
        blobToImgApi,
        getUserEmployee,
      ),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async generateQRCode(data) {
    try {
      return await QRCode.toDataURL(data);
    } catch (err) {
      console.error("Error generating QR Code", err);
      return null;
    }
  }

  async getUserEmployee(id) {
    const collection = "employees";
    const query = {
      where: {
        id: id,
      },
    };
    const response = await this.findObjectUseCase.execute(collection, query);
    return response[0];
  }

  onChangeEmployment(value, field, id = crypto.randomUUID()) {
    let index = this.employmentBackground.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.employmentBackground.push({ id });
      index = this.employmentBackground.length - 1;
    }
    this.employmentBackground[index][field] = value;
  }

  onChangecharacteref(value, field, id = crypto.randomUUID()) {
    let index = this.characterReferences.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.characterReferences.push({ id });
      index = this.characterReferences.length - 1;
    }
    this.characterReferences[index][field] = value;
  }

  // onChangePersonal(value, field) {
  //   this.personal[field] = value;
  //   const isAddressSame = this.view.state.isAddressSame;
  // }

  deleteImage() {
    delete this.personal["image1"];
  }

  syncAddress(data) {
    data["permanent_houseNumber"] = data["present_houseNumber"];
    data["permanent_street"] = data["present_street"];
    data["permanent_subdivision"] = data["present_subdivision"];
    data["permanent_barangay"] = data["present_barangay"];
    data["permanent_city"] = data["present_city"];
    data["permanent_province"] = data["present_province"];
    data["permanent_zipCode"] = data["present_zipCode"];
    data["telephone"] = data["present_telephone"];
  }
  onChangePersonal(value, field) {
    this.personal[field] = value;
    console.log(this.personal);
  }

  onChangeRecruiter(event) {
    const selectedRecruiterId = event.target.value;
    this.recruiter = selectedRecruiterId;
  }

  onChangeJobPosition(event) {
    const positionTitle = event.target.value;
    this.position = positionTitle;
  }

  removeEmployment(id) {
    delete this.employmentBackground[id];
  }

  removeCharacterRef(id) {
    delete this.characterref[id];
  }

  validateInputs() {
    const uploadedImage = this.view.state.image;
    if (!this.personal["coe"] || this.personal["coe"].trim() === "") {
      return false;
    }

    if (
      !this.personal["trainingCertificate"] ||
      this.personal["trainingCertificate"].trim() === ""
    ) {
      return false;
    }

    return true;
  }

  removeAllIsUntilPresentEmployment(data) {
    data.employmentBackground = data.employmentBackground.map((entry) => {
      const { isUntilPresentEmployment, ...rest } = entry;

      if (isUntilPresentEmployment === true) {
        delete rest.dateEmployedTo;
      }

      return rest;
    });
  }

  exludedFields(data) {
    if (data.isUntilPresent === true) {
      delete data.yearEndDateHs;
    }
    if (data.isUntilPresentCol === true) {
      delete data.yearEndDateCol;
    }
    delete data.isUntilPresent;
    delete data.isUntilPresentCol;
  }
  async onUpdate() {
    const collection = this.view.getCollectionName();
    const { object, isAddressSame } = this.view.state;
    const data = {
      ...this.object,
      ...this.personal,
      characterReferences: [
        ...this.characterReferences,
        ...(object.characterReferences || []),
      ],
      employmentBackground: [
        ...this.employmentBackground,
        ...(object.employmentBackground || []),
      ],
      coordinator: { id: object.coordinator?.id },
      recruiter: { id: object.recruiter?.id },
      applicant: { id: object.applicant?.id },
    };
    this.exludedFields(data);
    this.removeAllIsUntilPresentEmployment(data);
    if (isAddressSame) {
      this.syncAddress(data);
    }

    console.log(data);
    try {
      this.view.showProgress();

      await Promise.all([
        ...data.employmentBackground.map((employment) =>
          this.upsertUseCase.execute("employment_background", employment),
        ),
        ...data.characterReferences.map((ref) =>
          this.upsertUseCase.execute("character_references", ref),
        ),
      ]);

      const applicationData = await this.upsertUseCase.execute(
        collection,
        data,
      );

      this.view.successModal("Application updated successfully");
      this.view.setState({ object: applicationData });
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }

  async handleClickSchedule(startDateTime, endDateTime) {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const getUserEmployee = await this.getUserEmployee(user.employee.id);
    const applicantId = this.object.id || this.view.getObjectId();
    const getApplicantEmail = this.object?.applicant?.email;

    if (!applicantId) return;

    this.object.newStartDateTime = formatDate(new Date(startDateTime));
    this.object.newEndDateTime = formatDate(new Date(endDateTime));
    this.object.status = "For Interview";
    this.object.applicant = {
      id: this.object.applicant?.id,
    };
    this.object.recruiter = {
      id: this.object.recruiter?.id,
    };

    try {
      const data = await this.upsertUseCase.execute(collection, this.object);

      const resRecruiter = await this.findObjectUseCase.execute("users", {
        where: { id: data?.recruiter?.id },
        include: ["employee"],
      });

      console.log("resRecruiter", resRecruiter);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      console.log("data", data);

      // Extract required fields from the response
      const {
        firstName,
        lastName,
        newStartDateTime,
        newEndDateTime,
        recruiter,
        positionApplied,
      } = data;
      console.log("rrr", recruiter);
      const qrData = `${firstName}/${lastName}/${newStartDateTime}/${newEndDateTime}/${recruiter?.id}/${resRecruiter[0]?.employee?.firstName}/${resRecruiter[0]?.employee?.middleName}/${resRecruiter[0]?.employee?.lastName}/${resRecruiter[0]?.employee?.id}/${positionApplied}`;

      // Generate QR code and send email if successful
      const qrCode = await this.generateQRCode(qrData);

      if (!qrCode.startsWith("data:image/")) {
        console.error("Invalid Base64 format");
        return;
      }

      const blob = base64ToBlob(qrCode, "image/png");

      const file = new File([blob], "image.png", { type: "image/png" });

      const blobToImgApi = await saveImageUseCase().execute(file);

      console.log("blobToIm", blobToImgApi);

      if (!qrCode) {
        console.error("QR Code generation failed");
        return;
      }

      this.getObject();

      this.sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail);

      // ADDED CODE: Save the interview schedule to recruiter_calendar collection
      try {
        const startDate = new Date(startDateTime).toISOString().split("T")[0]; // YYYY-MM-DD
        const endDate = new Date(endDateTime).toISOString().split("T")[0]; // YYYY-MM-DD
        const startTime = new Date(startDateTime)
          .toTimeString()
          .split(" ")[0]
          .substring(0, 5); // HH:MM
        const endTime = new Date(endDateTime)
          .toTimeString()
          .split(" ")[0]
          .substring(0, 5); // HH:MM

        const applicantId = this.object.applicant?.id;
        const recruiterId = this.object.recruiter?.id;

        if (!applicantId || !recruiterId) {
          console.error("Missing applicant ID or recruiter ID");
          return;
        }

        const applicantFormQuery = {
          where: {
            "applicant.id": this.object.applicant?.id,
          },
        };

        const applicantFormData = await this.findObjectUseCase.execute(
          "online_applicants",
          applicantFormQuery,
        );

        let applicationFormId = null;
        let firstName = null;
        let middleName = null;
        let lastName = null;
        if (applicantFormData && applicantFormData.length > 0) {
          applicationFormId = this.object.id;
          firstName = this.object.firstName;
          middleName = this.object.middleName;
          lastName = this.object.lastName;
        }

        const existingCalendarQuery = {
          where: {
            applicantFormId: applicationFormId,
          },
        };

        const existingCalendarEntries = await this.findObjectUseCase.execute(
          "recruiter_calendar",
          existingCalendarQuery,
        );

        const calendarEntry = {
          startDate: startDate,
          endDate: endDate,
          startTime: startTime,
          endTime: endTime,
          applicant: { id: this.object.applicant?.id },
          recruiter: { id: recruiter?.id },
          applicationType: "online",
          applicantFormId: applicationFormId || null,
          applicantName: `${firstName} ${middleName} ${lastName}`,
        };

        let calendarResult;

        if (existingCalendarEntries && existingCalendarEntries.length > 0) {
          calendarEntry.id = existingCalendarEntries[0].id;
          calendarResult = await this.upsertUseCase.execute(
            "recruiter_calendar",
            calendarEntry,
          );
          console.log(
            "Interview schedule updated in recruiter calendar:",
            calendarResult,
          );
        } else {
          calendarResult = await this.upsertUseCase.execute(
            "recruiter_calendar",
            calendarEntry,
          );
          console.log(
            "New interview saved to recruiter calendar:",
            calendarResult,
          );
        }
      } catch (calendarError) {
        console.error("Error saving to recruiter calendar:", calendarError);
      }
      // END OF ADDED CODE
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  async handleClickOnboard(startDateTime, endDateTime) {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const getUserEmployee = await this.getUserEmployee(user.employee.id);
    const applicantId = this.object.id || this.view.getObjectId();
    const getApplicantEmail = this.object?.applicant?.email;

    if (!applicantId) return;

    this.object.onBoardStartTime = startDateTime;
    this.object.onBoardEndTime = endDateTime;
    this.object.status = "On-boarding";

    this.object.applicant = {
      id: this.object?.applicant?.id,
    };
    this.object.recruiter = {
      id: this.object?.recruiter?.id,
    };
    this.object.coordinator = {
      id: this.object?.coordinator?.id,
    };

    delete this.object.applicant.employee;

    try {
      const data = await this.upsertUseCase.execute(collection, this.object);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      // Extract required fields from the response
      const {
        firstName,
        lastName,
        onBoardStartTime,
        onBoardEndTime,
        recruiter,
        positionApplied,
      } = data;
      console.log("data", data);
      const qrData = `${firstName}/${lastName}/${onBoardStartTime}/${onBoardEndTime}/${recruiter?.id}/${recruiter?.firstName}/${recruiter?.middleName}/${recruiter?.lastName}/${recruiter?.id}/${positionApplied}`;

      // Generate QR code and send email if successful
      const qrCode = await this.generateQRCode(qrData);

      if (!qrCode.startsWith("data:image/")) {
        console.error("Invalid Base64 format");
        return;
      }

      const blob = base64ToBlob(qrCode, "image/png");

      const file = new File([blob], "image.png", { type: "image/png" });

      const blobToImgApi = await saveImageUseCase().execute(file);

      console.log("blobToIm", blobToImgApi);

      if (!qrCode) {
        console.error("QR Code generation failed");
        return;
      }

      this.sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  async getClients() {
    const collection = "clients";

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }
      const clients = await this.findObjectUseCase.execute(collection);

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.clients) !== JSON.stringify(clients)) {
          return { clients: clients };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching clients:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getLocations() {
    const collection = "locations";

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }

      const objects = await this.findObjectUseCase.execute(collection);

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.positions) !== JSON.stringify(objects)) {
          return { locations: objects };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching locations:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getRecruiter(id) {
    if (!id) return null;

    const collection = "users";
    const params = { include: ["all"] };

    try {
      this.view.showProgress();
      return await this.getObjectUseCase.execute(collection, id, { params });
    } catch (error) {
      this.view.showError(error);
      return null;
    } finally {
      this.view.hideProgress();
    }
  }

  async handleBackToPoll() {
    const collection = "reprocess_applicants";
    const currentId = this.view.getCurrentUser();
    const currentUser = await this.getRecruiter(currentId.id);
    console.log(currentUser);

    if (!this.object?.id) {
      console.error("Error: Missing object ID");
      this.view.showError("Failed to reprocess: Missing object ID.");
      return;
    }

    const { recruiter, ...updatedObject } = this.object;
    const remarks = this.view.state.remarks;
    updatedObject.status = "New";
    updatedObject.applicant = {
      id: updatedObject?.applicant?.id,
    };
    updatedObject.previousRecruiter = `${currentUser?.employee?.firstName} 
    ${currentUser?.employee?.middleName} ${currentUser?.employee?.lastName}`;
    updatedObject.pollRemarks = remarks;

    try {
      this.view.showProgress();

      await this.upsertUseCase.execute(collection, updatedObject);

      await this.deleteObjectUseCase.execute(
        "online_applicants",
        this.object.id,
      );

      //ADDED CODE
      const calendarQuery = {
        where: {
          applicantFormId: this.object.id, // Match the applicantFormId with the current object ID
        },
      };

      const calendarEntries = await this.findObjectUseCase.execute(
        "recruiter_calendar",
        calendarQuery,
      );

      if (calendarEntries && calendarEntries.length > 0) {
        for (const entry of calendarEntries) {
          await this.deleteObjectUseCase.execute(
            "recruiter_calendar",
            entry.id, // Delete each matching entry
          );
        }
      }
      //END OF ADDED CODE

      dialog.fire({
        html: (
          <DialogSuccess
            message={"The application has been successfully removed"}
          />
        ),
        footer: false,
      });

      this.view.navigateTo("/me/recruiter/online-applicants");
    } catch (error) {
      console.error("Error in handleBackToPoll:", error);
      this.view.showError("An error occurred");
    } finally {
      this.view.hideProgress();
    }
  }

  async navigateToForm() {
    const selectedPosition = this.view.state.selectedPosition;
    const datas = this.object;
    const object = this.view.state.object;

    if (selectedPosition != "") {
      try {
        let application = {};

        application = {
          ...datas,
          positionApplied: selectedPosition,
          applicant: {
            id: datas?.applicant?.id,
          },
          recruiter: {
            id: datas?.recruiter?.id,
          },
        };

        const interviewFormData = await this.upsertUseCase.execute(
          "online_applicants",
          application,
        );

        if (interviewFormData) {
          dialog.close();
          this.view.navigateTo(`/interview/form/online/${object?.id}`);
        }
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    } else {
      dialog.close();
      this.view.navigateTo(`/interview/form/online/${object?.id}`);
    }
  }

  async continueSubmit() {
    const coordinatorId = this.view.state.coordinatorId;
    const image = this.view.state.image;
    const datas = this.object;
    const interviewDatas = JSON.parse(
      sessionStorage.getItem("interviewDatasOnline"),
    );

    if (coordinatorId != "") {
      try {
        let application = {};

        application = {
          ...datas,
          coordinator: {
            id: coordinatorId,
          },
          applicant: {
            id: datas.applicant?.id,
          },
          recruiter: {
            id: datas.recruiter?.id,
          },
          image2: image,
          interviewCoordinator: "online",
          status: "For Coordinator",
        };

        const interviewFormData = await this.upsertUseCase.execute(
          "interview_form",
          interviewDatas,
        );

        const coordinatorData = await this.upsertUseCase.execute(
          "online_applicants",
          application,
        );

        sessionStorage.removeItem("interviewDatasOnline");
        dialog.close();
        this.view.setState({ object: coordinatorData });
        dialog.fire({
          html: <DialogSuccess message={"Data has been successfully saved"} />,
          footer: false,
        });
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
        console.log(error);
      }
    } else {
      this.view.showDialogWarning("All fields are required.");
    }
  }
  async getApplicantsEmail(id) {
    if (!id) return;
    try {
      this.view.showProgress();
      const object = await this.getObjectUseCase.execute("users", id);
      return object?.email;
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }

  // async generateEmployeeNumber() {
  //   try {
  //     const employees = await this.findObjectUseCase.execute("employees");
  //     const employeeLength = employees?.length || 0;

  //     const nextNumber = employeeLength + 1;

  //     const padded = String(nextNumber).padStart(2, "0");

  //     return padded;
  //   } catch (error) {
  //     console.error("Error generating employee number:", error);
  //     return "01";
  //   }
  // }

  async onNotHire(object) {
    const user = this.view.getCurrentUser();
    const updatedObject = {
      ...object,
      status: "Not Hired",
      applicant: { id: object.applicant?.id },
      coordinator: { id: object.coordinator?.id },
      recruiter: { id: object.recruiter?.id },
      interviewForm: { id: object.interviewForm?.id },
    };
    const applicationType = object?.interviewCoordinator;
    const collection = {
      online: "online_applicants",
      walkIn: "walkIn_applicants",
      reprocess: "reprocess_applicants",
    }[applicationType];
    try {
      const object = await this.upsertUseCase.execute(
        collection,
        updatedObject,
      );
      this.view.setState({ object: object });

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "On boarding",
        description: "Applicantion's Rejected ",
        application_id: this.object?.id,
      };

      await this.auditUseCase.execute(auditObject);

      this.view.showSuccess("Application updated Successfully");
    } catch (error) {
      console.log("Error", error);
    }
  }

  generateReferenceNumber() {
    const year = new Date().getFullYear();
    const shortId = crypto.randomUUID().split("-")[0].toUpperCase(); // e.g. "A1B2C3D4"
    return `LGS-${year}-${shortId}`;
  }

  // async handleClickHireApplicant(
  //   object,
  //   endDateTime,
  //   employmentStatus,
  //   department,
  // ) {
  //   if (!object?.id) return;

  //   const applicationType = object?.interviewCoordinator;
  //   const collection = {
  //     online: "online_applicants",
  //     walkIn: "walkIn_applicants",
  //     reprocess: "reprocess_applicants",
  //   }[applicationType];

  //   try {
  //     const user = this.view.getCurrentUser();
  //     const getUserEmployee = await this.getUserEmployee(user.employee.id);
  //     const getApplicantEmail = await this.getApplicantsEmail(
  //       object?.applicant?.id,
  //     );

  //     Object.assign(object, {
  //       endDate: endDateTime,
  //       employmentStatus,
  //       department,
  //       status: "Hired",
  //       applicant: { id: object.applicant.id },
  //       coordinator: { id: object.coordinator.id },
  //       recruiter: { id: object.recruiter.id },
  //     });

  //     if (endDateTime) {
  //       object.endDate = endDateTime;
  //     } else {
  //       delete object.endDate;
  //     }

  //     // const today = new Date();
  //     // const YY = String(today.getFullYear()).slice(-2);
  //     // const MM = String(today.getMonth() + 1).padStart(2, "0");
  //     // const DD = String(today.getDate()).padStart(2, "0");

  //     // const empNumber = await this.generateEmployeeNumber();

  //     // let employeeID = "";
  //     // if (object?.deploymentType === "Deployed") {
  //     //   employeeID = `LGS${YY}-${MM}${DD}${empNumber}`;
  //     // } else if (object?.deploymentType === "Direct Employee") {
  //     //   employeeID = `${YY}${empNumber}${MM}${DD}`;
  //     // }

  //     console.log(
  //       "this.generateReferenceNumber()",
  //       this.generateReferenceNumber(),
  //     );

  //     const updatedObject = {
  //       ...object,
  //       status: "Active",
  //       position: object.positionApplied,
  //       mobileNumber: object.present_telephone,
  //       employeeID: this.generateReferenceNumber(),
  //     };
  //     delete updatedObject?.deploymentType;
  //     delete updatedObject?.pollRemarks;
  //     delete updatedObject?.previousRecruiter;
  //     delete updatedObject?.interviewForm;
  //     delete updatedObject?.prevInterviewForm;
  //     delete updatedObject?.rejectionReason;

  //     console.log("updatedObject", updatedObject);

  //     const [data, employee] = await Promise.all([
  //       this.upsertUseCase.execute(collection, object),
  //       this.upsertUseCase.execute("employees", updatedObject),
  //     ]);

  //     if (!data || typeof data !== "object") {
  //       console.warn("Invalid response data");
  //       return;
  //     }

  //     // SEMICOLON;
  //     try {
  //       const submitPayload = {
  //         employee_code: employee?.employeeID,
  //         first_name: employee?.firstName,
  //         middle_name: employee?.middleName || undefined,
  //         surname: employee?.lastName,
  //         date_of_birth: employee?.birthDate,
  //         position: employee?.position,
  //         department: department || "-",
  //         phone_number: employee?.mobileNumber || employee?.present_telephone,
  //         email: employee?.email,
  //         emergency_fullname: employee?.contact_name,
  //         emergency_relationship: employee?.contact_relationship,
  //         emergency_address: {
  //           emergency_subdivision: employee?.contact_subdivision,
  //           emergency_barangay: employee?.contact_barangay,
  //           emergency_city: employee?.contact_city,
  //           emergency_province: employee?.contact_province,
  //           emergency_zipcode: employee?.contact_zipCode,
  //           emergency_telephone: employee?.contact_telephone,
  //         },
  //         extra_data: {
  //           status: employee?.status,
  //           employment_status: employmentStatus,
  //           deployment_type: "-",
  //         },
  //       };

  //       const semicolonResponse = await submitEmployee(submitPayload);

  //       if (semicolonResponse?.message === "employee_saved") {
  //         console.log("Employee submitted to Semicolon Studios successfully.");
  //       } else {
  //         console.warn("Semicolon Studios response:", semicolonResponse);
  //       }
  //     } catch (submitError) {
  //       // Non-blocking — don't stop the hiring process if API call fails
  //       console.error("Semicolon Studios /submit error:", submitError);
  //     }

  //     // SEMICOLON;

  //     const qrData = `${data.firstName}-${data.lastName}-${data.hireStartDate}-${data.hireEndDate}`;
  //     const qrCode = await this.generateQRCode(qrData);

  //     if (!qrCode?.startsWith("data:image/")) {
  //       console.error("Invalid QR Code format");
  //       return;
  //     }

  //     const blobToImgApi = await saveImageUseCase().execute(
  //       new File([base64ToBlob(qrCode, "image/png")], "image.png", {
  //         type: "image/png",
  //       }),
  //     );

  //     const auditObject = {
  //       user: { id: user?.id },
  //       action: "UPDATE",
  //       module: "On boarding",
  //       description: "Applicant Hired",
  //       application_id: this.object?.id,
  //     };

  //     await this.auditUseCase.execute(auditObject);

  //     dialog.close();
  //     this.sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail);
  //     this.view.setState({ object: object });
  //     this.view.showSuccess("Applicant Hired Successfully");
  //   } catch (error) {
  //     console.error("Error:", error);
  //     this.view.showError(error);
  //   }
  // }

  async handleClickHireApplicant(
    object,
    endDateTime,
    employmentStatus,
    department,
  ) {
    if (!object?.id) return;

    const applicationType = object?.interviewCoordinator;
    const collection = {
      online: "online_applicants",
      walkIn: "walkIn_applicants",
      reprocess: "reprocess_applicants",
    }[applicationType];

    try {
      const user = this.view.getCurrentUser();
      const getUserEmployee = await this.getUserEmployee(user.employee.id);
      const getApplicantEmail = await this.getApplicantsEmail(
        object?.applicant?.id,
      );

      Object.assign(object, {
        endDate: endDateTime,
        employmentStatus,
        department,
        status: "Hired",
        applicant: { id: object.applicant.id },
        coordinator: { id: object.coordinator.id },
        recruiter: { id: object.recruiter.id },
      });

      if (endDateTime) {
        object.endDate = endDateTime;
      } else {
        delete object.endDate;
      }

      const updatedObject = {
        ...object,
        status: "Active",
        position: object.positionApplied,
        mobileNumber: object.present_telephone,
        employeeID: this.generateReferenceNumber(),
      };
      delete updatedObject?.deploymentType;
      delete updatedObject?.pollRemarks;
      delete updatedObject?.previousRecruiter;
      delete updatedObject?.interviewForm;
      delete updatedObject?.prevInterviewForm;
      delete updatedObject?.rejectionReason;

      const submitPayload = {
        employee_code: updatedObject?.employeeID,
        first_name: updatedObject?.firstName,
        middle_name: updatedObject?.middleName || undefined,
        surname: updatedObject?.lastName,
        date_of_birth: updatedObject?.birthDate,
        position: updatedObject?.position,
        department: department || "-",
        phone_number:
          updatedObject?.mobileNumber || updatedObject?.present_telephone,
        email: updatedObject?.email,
        emergency_fullname: updatedObject?.contact_name,
        emergency_relationship: updatedObject?.contact_relationship,
        emergency_address: {
          emergency_subdivision: updatedObject?.contact_subdivision,
          emergency_barangay: updatedObject?.contact_barangay,
          emergency_city: updatedObject?.contact_city,
          emergency_province: updatedObject?.contact_province,
          emergency_zipcode: updatedObject?.contact_zipCode,
          emergency_telephone: updatedObject?.contact_telephone,
        },
        extra_data: {
          status: updatedObject?.status,
          employment_status: employmentStatus,
          deployment_type: "-",
        },
      };

      const semicolonResponse = await submitEmployee(submitPayload);

      if (semicolonResponse?.error) {
        throw new Error(`Semicolon API error: ${semicolonResponse.error}`);
      }

      if (semicolonResponse?.code !== "employee_saved") {
        throw new Error(
          `Semicolon API unexpected response: ${JSON.stringify(semicolonResponse)}`,
        );
      }

      console.log("Employee submitted to Semicolon Studios successfully.");

      const [data, employee] = await Promise.all([
        this.upsertUseCase.execute(collection, object),
        this.upsertUseCase.execute("employees", updatedObject),
      ]);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      const qrData = `${data.firstName}-${data.lastName}-${data.hireStartDate}-${data.hireEndDate}`;
      const qrCode = await this.generateQRCode(qrData);

      if (!qrCode?.startsWith("data:image/")) {
        console.error("Invalid QR Code format");
        return;
      }

      const blobToImgApi = await saveImageUseCase().execute(
        new File([base64ToBlob(qrCode, "image/png")], "image.png", {
          type: "image/png",
        }),
      );

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "On boarding",
        description: "Applicant Hired",
        application_id: this.object?.id,
      };

      await this.auditUseCase.execute(auditObject);

      dialog.close();
      this.sendEmail(qrData, blobToImgApi, getUserEmployee, getApplicantEmail);
      this.view.setState({ object: object });
      this.view.showSuccess("Applicant Hired Successfully");
    } catch (error) {
      console.error("Error:", error);
      this.view.showError(error);
    }
  }

  onClickPrint() {
    this.view.exportPDF();
  }

  async getJobPositions() {
    const collection = "job_posting";
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();

    try {
      if (this.findObjectUseCase?.abort) {
        this.findObjectUseCase.abort();
      }

      const objects = await this.findObjectUseCase.execute(collection, {
        where: { deadline: { $gte: todayISO } },
      });

      this.view.setState((prevState) => {
        if (JSON.stringify(prevState.positions) !== JSON.stringify(objects)) {
          return { positions: objects };
        }
        return null;
      });
    } catch (error) {
      console.error("Error fetching job positions:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }
}

export default ApplicantBoardingFormPresenter;
